import {
  captureExceptionLazy,
  getLoadedSentry,
  loadSentry,
  sentryEnabled
} from '@/lib/sentry/lazy';

if (sentryEnabled && typeof window !== 'undefined') {
  const onError = (event: ErrorEvent) => {
    captureExceptionLazy(event.error ?? event.message);
  };
  const onRejection = (event: PromiseRejectionEvent) => {
    captureExceptionLazy(event.reason);
  };
  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);

  const warm = () => {
    const idle =
      typeof window.requestIdleCallback === 'function'
        ? window.requestIdleCallback
        : (cb: () => void) => window.setTimeout(cb, 1500);
    idle(() => {
      loadSentry()?.then(() => {
        window.removeEventListener('error', onError);
        window.removeEventListener('unhandledrejection', onRejection);
      });
    });
  };

  if (document.readyState === 'complete') {
    warm();
  } else {
    window.addEventListener('load', warm, { once: true });
  }
}

export const onRouterTransitionStart = (
  href: string,
  navigationType: string
): void => {
  getLoadedSentry()?.captureRouterTransitionStart(href, navigationType);
};
